export { GetStartedAuth } from "#get-started-auth";
